import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { ToastEvent } from '.';
import { ToastService } from '../../shared/foundation/toast/toast.service';

@Component({
  selector: 'app-toaster',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToasterComponent implements OnInit {
  currentToasts: ToastEvent[] = [];

  constructor(
    private toastService: ToastService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.subscribeToToasts();
  }

  subscribeToToasts(): void {
    this.toastService.toastEvents.subscribe((toasts: ToastEvent) => {
      const currentToast: ToastEvent = {
        type: toasts.type,
        message: toasts.message,
        delay: toasts.delay,
      };
      this.currentToasts.push(currentToast);
      this.cdr.detectChanges();
    });
  }

  dispose(index: number): void {
    this.currentToasts.splice(index, 1);
    this.cdr.detectChanges();
  }
}
